import { requiredRule, getRuleLen } from '../../../../utils/rules';
import { Button, DatePicker, Form, Icon, Input, Toast, Upload } from '@roo/roo';
import React from 'react';
import { UploadField } from '../../_components/UploadField';
import { FieldList } from '../../_components/FieldList';
import { getPopContainer } from '../../_utils';
import dayjs from 'dayjs';
import { getSafeDate } from '../../../../utils/utils';

const { Field } = Form;

const honorData = {
  honorTime: '',
  honorProjectName: '',
  honorRank: '',
  honorInstitution: '',
  fileUrl: '',
};

export const Honor = function (props) {
  return (
    <FieldList
      {...props}
      name={'honorInfo'}
      maxCount={5}
      minCount={0}
      plusText={'添加荣誉'}
      iniData={honorData}
      itemClassName={'form-patch bc'}
    >
      <Field
        required={true}
        rule={requiredRule}
        name={`honorTime`}
        label='获奖时间'
        placeholder={'请选择获奖时间'}
      >
        {({ value, handleChange, disabled }) => {
          return (
            <DatePicker
              disabled={disabled}
              popupContainer={getPopContainer}
              format={'YYYY-MM-DD'}
              valueOfType={'string'}
              value={getSafeDate(value)}
              onChange={handleChange}
              placeholder={'请选择获奖时间'}
            />
          );
        }}
      </Field>
      <Field
        required={true}
        rule={getRuleLen(50, true)}
        name={`honorProjectName`}
        label='获奖项目名称'
        as={<Input maxLength={50} placeholder={'请输入获奖项目名称'} />}
      />
      <Field
        required={true}
        rule={getRuleLen(50, true)}
        name={`honorRank`}
        label='奖项等级及排名'
        as={<Input maxLength={50} placeholder={'请输入奖项等级及排名'} />}
      />
      <Field
        required={true}
        rule={getRuleLen(50, true)}
        name={`honorInstitution`}
        label='授奖机构名称'
        as={<Input maxLength={50} placeholder={'请输入授奖机构名称'} />}
      />
      <Field
        label='证书上传'
        layout='vertical'
        name={`fileUrl`}
        required={true}
        rule={{ ...requiredRule }}
      >
        {({ value, handleChange }) => {
          return <UploadField type={'img'} value={value} handleChange={handleChange} />;
        }}
      </Field>
    </FieldList>
  );
};
